import { useEffect } from 'react';

const RELOAD_GUARD_PREFIX = 'ashkelon-chunk-reload:';

/**
 * After a deploy, a long-lived tab can keep old JS while the server serves
 * new HTML/chunks. Vite emits `vite:preloadError` when a lazy chunk 404s;
 * reload once per session so users recover without a manual hard refresh.
 */
export function ClientRecovery() {
    useEffect(() => {
        const reloadOnce = (key: string) => {
            const guardKey = `${RELOAD_GUARD_PREFIX}${key}`;
            if (sessionStorage.getItem(guardKey)) return;
            sessionStorage.setItem(guardKey, '1');
            window.location.reload();
        };

        const onPreloadError = (event: Event) => {
            event.preventDefault();
            reloadOnce('vite-preload');
        };

        window.addEventListener('vite:preloadError', onPreloadError);
        return () => {
            window.removeEventListener('vite:preloadError', onPreloadError);
        };
    }, []);

    return null;
}
